import { IMagniteCTVTier } from '~/src/dash/api/demand-settings/magnitectv/magnitectv-tiers_models';
import { createUrl, restGet, restPatch } from '~/src/dash/api/rest';
import { EBool } from '~/src/dash/api/types/bool';

export async function getMagniteCTVTiersForPublisher(
  publisherID: string,
): Promise<[IMagniteCTVTier[] | undefined, Error | undefined]> {
  const reqUrl = createUrl('/publishers/' + publisherID + '/magnitectv-tiers', publisherID);

  try {
    return [(await restGet<IMagniteCTVTier[]>(reqUrl)).parsedBody as IMagniteCTVTier[], undefined];
  } catch (e) {
    return [undefined, e];
  }
}

export async function updateMagniteCTVTiersForPublisher(
  publisherID: string,
  tiers: IMagniteCTVTier[],
): Promise<[IMagniteCTVTier[] | undefined, Error | undefined]> {
  const reqUrl = createUrl('/publishers/' + publisherID + '/magnitectv-tiers', publisherID);

  try {
    return [
      (await restPatch<IMagniteCTVTier[]>(reqUrl, tiers)).parsedBody as IMagniteCTVTier[],
      undefined,
    ];
  } catch (e) {
    return [undefined, e];
  }
}

// is enabled?
export async function getMagniteCTVTiersEnabledForPublisher(
  publisherID: string,
): Promise<[EBool | undefined, Error | undefined]> {
  const reqUrl = createUrl('/publishers/' + publisherID + '/magnitectv-tiers-enabled', publisherID);

  try {
    return [(await restGet<EBool>(reqUrl)).parsedBody as EBool, undefined];
  } catch (e) {
    return [undefined, e];
  }
}

export async function updateMagniteCTVTiersEnabledForPublisher(
  publisherID: string,
  isEnabled: EBool,
): Promise<[EBool | undefined, Error | undefined]> {
  const reqUrl = createUrl('/publishers/' + publisherID + '/magnitectv-tiers-enabled', publisherID);

  try {
    return [(await restPatch<EBool>(reqUrl, isEnabled)).parsedBody as EBool, undefined];
  } catch (e) {
    return [undefined, e];
  }
}
